import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { GlobalService } from '../../services/global.service';
import { MyPosProvider } from '../../providers/my-pos/my-pos';
/**
 * Generated class for the InvoicePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-invoice',
  templateUrl: 'invoice.html',
})
export class InvoicePage {

  constructor(public navCtrl: NavController, public navParams: NavParams, private global: GlobalService,public PosProvider:MyPosProvider) {

  }

  ionViewDidLoad() {
    this.global.post("/groups/addInvoice",
      {
        date: "2018-3-4",
        total: 34,
        items: [
          {
            item_serial: 3,
            amount: 3,
            price: 43
          }
        ]
      },
      (data) => { },
      (error) => { },
      1);
  }

}



// WEBPACK FOOTER //
// ./src/pages/invoice/invoice.ts